<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading" :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">厕所设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="厕所编号" prop="tId">
                <el-input
                  v-model="data.tId"
                  :disabled="!IsEdit || isDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="厕所名称" prop="name">
                <el-input
                  v-model="data.name"
                  :disabled="!IsEdit || isDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="男厕间数" prop="maleNum">
                <el-input
                  v-model.number="data.maleNum"
                  :disabled="!IsEdit || isDisabled"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="女厕间数" prop="femaleNum">
                <el-input
                  v-model.number="data.femaleNum"
                  :disabled="!IsEdit || isDisabled"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="混合厕间数" prop="mixedNum">
                <el-input
                  v-model.number="data.mixedNum"
                  :disabled="!IsEdit || isDisabled"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="第三厕间数" prop="thirdNum">
                <el-input
                  v-model.number="data.thirdNum"
                  :disabled="!IsEdit || isDisabled"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="IP地址" prop="ipAddr">
                <el-input
                  v-model="data.ipAddr"
                  :disabled="!IsEdit || isDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="区域" prop="BELONGAREA">
                <el-select
                  v-model="data.BELONGAREA"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in EqRegionArr"
                    :key="item.RegionId"
                    :label="item.RegionName"
                    :value="item.RegionId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="longitude">
                <el-input
                  v-model="data.longitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="[IsEdit ? 11 : 12]">
              <el-form-item label="纬度" prop="latitude">
                <el-input
                  v-model="data.latitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="data.latitude"
              :point_lng="data.longitude"
              @onGotLngLat="onGotLngLat"
              v-if="IsEdit"
            ></ZjLngLatSelect>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="负责人" prop="linkPeople">
                <el-input
                  v-model="data.linkPeople"
                  :disabled="!IsEdit || isDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负责人电话" prop="linkPhone">
                <el-input
                  v-model="data.linkPhone"
                  :disabled="!IsEdit || isDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="厂家" prop="belongUnitName">
                <el-input
                  v-model="data.belongUnitName"
                  :disabled="!IsEdit || isDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="保修期" prop="PERIODDEFECTS">
                <el-input
                  v-model="data.PERIODDEFECTS"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import { queryToiletDetail, ToiletEdit } from "../../../apis/src/Query.js";
export default {
  name: "SmartTolietManagerInfo",
  controller: "UI",
  action: "SmartTolietManagerInfo",
  data() {
    return {
      data: {
        LATITUDE: "",
        LONGITUDE: "",
      },
      loading: false,
      loadingText: '加载中...',
      EqRegionArr: [],
      IsEdit: false,
      rules: {
        tId: [
          { required: true, message: "请输入厕所编号", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入厕所名称", trigger: "blur" },
        ],
        longitude: [
          {
            required: true,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        latitude: [
          {
            required: true,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        // BELONGAREA: [
        //   { required: true, message: "请选择区域", trigger: "change" },
        // ],
        maleNum: [
          {
            required: false,
            message: "请输入有效的男厕间数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
        femaleNum: [
          {
            required: false,
            message: "请输入有效的女厕间数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
        mixedNum: [
          {
            required: false,
            message: "请输入有效的混合厕间数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
        thirdNum: [
          {
            required: false,
            message: "请输入有效的第三厕间数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
      },
      isDisabled:true
    };
  },
  created: function () {
    if (this.$route.query.entityCode) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    onGotLngLat(obj) {
      this.data.latitude = obj.lat || 0;
      this.data.longitude = obj.lng || 0;
    },
    search() {
      let entityCode = this.$route.query.entityCode;
      if (entityCode) {
        this.loading = true;
        queryToiletDetail({entityCode}).then((r) =>{
          this.loading = false;
          console.log(r)
          if(r.code == 0){
            this.data = r.data;
          }else{
            this.$message({
              type: "error",
              message: r.msg
            });
          }
        })
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      this.loading = true;
      this.loadingText = "保存中..."
        let {entityCode, longitude, latitude} = this.data
        ToiletEdit({entityCode, longitude, latitude}).then((r) =>{
          this.loading = false;
          console.log(r)
          if(r.code == 0){
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          }else{
            this.loading = false;
            this.errmsg(r.msg ? r.msg : "服务异常，请联系管理员！");
          }
        })
    },
  },
};
</script>
